import ConfirmationModal from "commons/modal/ConfirmationModal";
import { Numerique } from "pages/gant/constantes/medias";
import GenericGrid from "pages/tables/GenericGrid";
import React, { useState } from "react";
import * as dates from 'commons/models/dates';
import PropTypes from 'prop-types';
import { useGetInstructionsMutation } from "../../../../redux/api/cache";

export default function Planification(props) {
    const isNumeric = props.media === Numerique;
    const [instructionModalVisible, setInstructionModalVisible] =
        useState(false);
    const [getInstructions] = useGetInstructionsMutation();
    const sendInstruction = async () => {
        await getInstructions({
            seq: props.camp_seq, media: props.media, date: dates.dateQueryFormatReverse(
                props.gridData?.data[0].campr_date
            ), diff: props.gridData?.data[0].diff_cd, mf_format: props.gridData?.data[0].mf_format
        }).unwrap();
    };

    return <>
        {instructionModalVisible && (
            <ConfirmationModal
                text={`Désirez-vous envoyer les instructions ?`}
                onClose={() => {
                    setInstructionModalVisible(false);
                }}
                onConfirm={() => {
                    setInstructionModalVisible(false);
                    sendInstruction();
                }}
            />
        )}
        <GenericGrid
            autoSize={true}
            rowClicked={() => { }}
            definition={props.gridData?.meta?.definition}
            camp_seq={props.selectedRow?.camp_seq}
            data={props.gridData?.data?.map(d => { if (d.div_num === 0) d.div_nom = "À définir"; return d; })}
            media={props.media}
            txtBtn2='Tout télécharger'
            txtBtn="Envoyer les instructions"
            showCreateBtn2={isNumeric}
            showCreateBtn={isNumeric}
            onCreateClick={() => setInstructionModalVisible(true)}
            onCreateClick2={() => props.documents?.data.map((file) =>
                window.open(
                    `http://10.20.2.34/DocPublicite${process.env.REACT_APP_ENV === 'dev' ? 'Dev' : ''}/${file.path}${file.nom}`,
                    '_blank'
                ))}
            planificationGrid={true}
            project={props.project}
        ></GenericGrid></>;
}

Planification.propTypes = {
    gridData: PropTypes.shape({
        data: PropTypes.array,
        meta: PropTypes.shape({
            definition: PropTypes.array,
        }),
    }),
    media: PropTypes.string,
    selectedRow: PropTypes.any,
    documents: PropTypes.any,
    project: PropTypes.any,
    camp_seq: PropTypes.any
};